module.exports = __webpack_public_path__ + "static/media/seller-bg.jpg";